import { Component, OnInit, ViewChild } from '@angular/core';
import { MyTaskType, MyTaskJobStatus, SalesOrder, GenTaskData, SOStatus } from '../shared/misc-classes';
import { DataService } from '../shared/dataservice.service';
@Component({
  selector: 'app-my-task',
  templateUrl: './my-task.component.html',
  styleUrls: ['./my-task.component.css']
})
export class MyTaskComponent implements OnInit {

    @ViewChild('userImpForm',{static: false}) userImpFrm;

   myTaskType:any = MyTaskType;
   myJobStatus:any = MyTaskJobStatus;

   userTaskType:number = MyTaskType.UNKNOWN;
   salesOrders:Array<SalesOrder>;

   tableData:any = {};
   search:string = ''; 
   
  constructor(private _dataService: DataService) { }

  ngOnInit() {
    this.tableData[MyTaskType.MARKETING] = {};
    this.tableData[MyTaskType.PROJECT_MANAGEMENT] = {};
    this.tableData[MyTaskType.SCM] = {};
    this.tableData[MyTaskType.ENGINEERING] = {};
    this.tableData[MyTaskType.PURCHASE_PO] = {};
    this.tableData[MyTaskType.PLANNING] = {};
    this.tableData[MyTaskType.MATERIAL_RECEIPT] = {};
    this.tableData[MyTaskType.STORES] = {};
    this.tableData[MyTaskType.PRODUCTION] = {};
    this.tableData[MyTaskType.TESTING] = {};
    this.tableData[MyTaskType.LOGISTICS] = {};
    
    this.userTaskType = this._dataService.userMyTaskType; 

    this.loadData();
  }

  private loadData(){
    this.salesOrders = null;
    this._dataService.getDataDefinitions().subscribe((_loadStatus:boolean) => {
      this._dataService.getAllSalesOrder_PR(1).subscribe((_soObjAr:Array<SalesOrder>) => {
        if(_soObjAr){
          // this.salesOrders = _soObjAr.filter((_tmpSO:SalesOrder) => {
          let so = _soObjAr.filter((_tmpSO: SalesOrder) => {
            //test the filter.
                if(_tmpSO.projectStatus == SOStatus.Dispatched || 
                    _tmpSO.projectStatus == SOStatus.Archived){
                  return false;
                }
                return true;
              });

          let _equpNeeded = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

          // Filter the SSO for the required equipment type
          so.map(function (Res) {
            Res.subSalesOrder.map(function (x) {
              x.pmTechSubSalesOrder.equipmentList = x.pmTechSubSalesOrder.equipmentList.filter(y => _equpNeeded.includes(y.equipmentType) == true)
            });
            return Res;
          }).filter(({ subSalesOrder }) => subSalesOrder);

          //  Filter the SSO for non empty equipment data
          so.map(function (Res) {
            Res.subSalesOrder = Res.subSalesOrder.filter(x =>
              x.pmTechSubSalesOrder.equipmentList.length > 0);
            return Res;
          }).filter(({ subSalesOrder }) => subSalesOrder);

          this.salesOrders = so;
        }
        else{
          //error handler
        }
        // this._dataService.getAll
      });
    });
  }


  isMarketingTaskEnabled():boolean{
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.MARKETING
      || this.userTaskType == MyTaskType.HEAD_MARKETING
      || this.userTaskType == MyTaskType.FINANCE
      || this.userTaskType == MyTaskType.HEAD_FINANCE){
      return true;
    }
    return false;
  }
  isProjectManagementEnabled():boolean{
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PROJECT_MANAGEMENT // ok ,specific
      || this.userTaskType == MyTaskType.HEAD_PROJECT_MANAGEMENT //ok
      || this.userTaskType == MyTaskType.ENGINEERING //ok, specific
      || this.userTaskType == MyTaskType.HEAD_ENGINEERING //ok
      || this.userTaskType == MyTaskType.MARKETING //ok, specific
      || this.userTaskType == MyTaskType.HEAD_MARKETING //ok
      || this.userTaskType == MyTaskType.FINANCE //ok
      || this.userTaskType == MyTaskType.HEAD_FINANCE //ok
      || this.userTaskType == MyTaskType.HEAD_SCM //ok
      || this.userTaskType == MyTaskType.SCM //ok, specific
      ){
      return true;
    }
    return false;
  }
  isSCMEnabled():boolean{
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.HEAD_SCM
      || this.userTaskType == MyTaskType.SCM){
      return true;
    }
    return false;
  }
  isEngineerngEnabled():boolean{
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.ENGINEERING //ok, specific
      || this.userTaskType == MyTaskType.HEAD_ENGINEERING //ok
      || this.userTaskType == MyTaskType.PROJECT_MANAGEMENT //ok, specific
      || this.userTaskType == MyTaskType.HEAD_PROJECT_MANAGEMENT //ok
      || this.userTaskType == MyTaskType.HEAD_SCM // ok
      || this.userTaskType == MyTaskType.SCM // ok, specific ???
      ){
      return true;
    }
    return false;
  }
  isPOEnabled():boolean{
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO // ok
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO // ok
      //|| this.userTaskType == MyTaskType.PROJECT_MANAGEMENT //
      //|| this.userTaskType == MyTaskType.HEAD_PROJECT_MANAGEMENT //
      //|| this.userTaskType == MyTaskType.HEAD_ENGINEERING //
      ){
      return true;
    }
    return false;
  }
  isPlanningEnabled():boolean{
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PLANNING
      || this.userTaskType == MyTaskType.PLANNING_PRODUCTION
      || this.userTaskType == MyTaskType.HEAD_PLANNING){
      return true;
    }
    return false;
  }
  isMaterialRcptEnabled():boolean{
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PURCHASE_PO
      || this.userTaskType == MyTaskType.HEAD_PURCHASE_PO){
      return true;
    }
    return false;
  }
  isStoresEnabled():boolean{
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.STORES
      || this.userTaskType == MyTaskType.HEAD_STORES
      ){
      return true;
    }
    return false;
  }
  IsProductionEnabled():boolean{
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.PRODUCTION
      || this.userTaskType == MyTaskType.HEAD_PRODUCTION
      || this.userTaskType == MyTaskType.PLANNING_PRODUCTION){
      return true;
    }
    return false;
  }
  isQualityEnabled():boolean{
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.TESTING
      || this.userTaskType == MyTaskType.HEAD_TESTING){
      return true;
    }
    return false;
  }
  isLogisticsEnabled():boolean{
    if(this.userTaskType == MyTaskType.ADMIN 
      || this.userTaskType == MyTaskType.LOGISTICS
      || this.userTaskType == MyTaskType.HEAD_LOGISTICS){
      return true;
    }
    return false;
  }


  _dataObj:string = '';
  downloadExcel(){

    //console.log(this.tableData[MyTaskType.MARKETING])
    this._dataObj = JSON.stringify(this.prepareDownloadObj());

    setTimeout(() => {
      this.userImpFrm.nativeElement.submit()  
    }, 10);
  }

  prepareDownloadObj():any{
    let _obj:any = {};
    _obj.userId = this._dataService.userId;
    _obj.userName = this._dataService.userName;
    _obj.userGroupId = '';
    _obj.userGroupName = '';

    _obj.taskgroups = [];

    this.prepareGroupData('Marketing',this.tableData[MyTaskType.MARKETING],_obj);
    this.prepareGroupData('Project Management',this.tableData[MyTaskType.PROJECT_MANAGEMENT],_obj);
    this.prepareGroupData('SCM',this.tableData[MyTaskType.SCM],_obj);
    this.prepareGroupData('Engineering',this.tableData[MyTaskType.ENGINEERING],_obj);
    this.prepareGroupData('PO',this.tableData[MyTaskType.PURCHASE_PO],_obj);
    this.prepareGroupData('Planning',this.tableData[MyTaskType.PLANNING],_obj);
    this.prepareGroupData('Material Receipt',this.tableData[MyTaskType.MATERIAL_RECEIPT],_obj);
    this.prepareGroupData('Stores',this.tableData[MyTaskType.STORES],_obj);
    this.prepareGroupData('Production',this.tableData[MyTaskType.PRODUCTION],_obj);
    this.prepareGroupData('Quality',this.tableData[MyTaskType.TESTING],_obj);
    this.prepareGroupData('Logistics',this.tableData[MyTaskType.LOGISTICS],_obj);

    //console.log(_obj)
    return _obj;
  }

  prepareGroupData(_groupName:string, _tableData:any, _obj:any){
    if(_tableData.delayedJobs){
      let _taskGroup:any = {};

      _taskGroup.taskGroupName = _groupName;
      _taskGroup.taskSubGroups = [];

      let _taskSubGroup:any = {};
      _taskSubGroup.taskSubGroupName = "Delayed";
      _taskSubGroup.totalTaskCount = _tableData.counters.delayedJobCounter;
      _taskSubGroup.parameterGroups = []
      let _jobs:Array<GenTaskData> = _tableData.delayedJobs;

      for(var i = 0;i < _jobs.length;i++){
        _taskSubGroup.parameterGroups.push(_jobs[i].getDownloadJson())
      }
      _taskGroup.taskSubGroups.push(_taskSubGroup);

      _taskSubGroup = {};
      _taskSubGroup.taskSubGroupName = "Running";
      _taskSubGroup.totalTaskCount = _tableData.counters.runningJobCounter;;
      _taskSubGroup.parameterGroups = []
      _jobs = _tableData.runningJobs;

      for(var i = 0;i < _jobs.length;i++){
        _taskSubGroup.parameterGroups.push(_jobs[i].getDownloadJson())
      }
      _taskGroup.taskSubGroups.push(_taskSubGroup);

      _taskSubGroup = {};
      _taskSubGroup.taskSubGroupName = "Upcoming";
      _taskSubGroup.totalTaskCount = _tableData.counters.upcomingJobCounter;;
      _taskSubGroup.parameterGroups = []
      _jobs = _tableData.upcomingJobs;

      for(var i = 0;i < _jobs.length;i++){
        _taskSubGroup.parameterGroups.push(_jobs[i].getDownloadJson())
      }
      _taskGroup.taskSubGroups.push(_taskSubGroup);

      _obj.taskgroups.push(_taskGroup);
    }
  }


  }
